module.exports = __webpack_public_path__ + "static/media/windsurfing_tiny.46a02d28.webp";